export default {
    stateRow: {
        display: "flex",
        columnGap: "20px",
        alignItems: "end",
    },
    cardInformation: {
        display: "flex",
        columnGap: "10px",
        justifyContent: "center",
        alignItems: "center"
    },
    pointer: {
        cursor: 'pointer',
    },
    addressSection: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '10px', 
        maxHeight: '450px', 
        overflowY: 'auto', 
        padding: '20px'
    },
    fullWidth: {
        width: '100%'
    }
}